import './DataPlaceholder.scss';

/**Shimmering placeholder span typically used in place of data while waiting for an ajax call to finish.
 * @param {Object} props Incoming jsx attributes.
 * @param {string} [props.className] Class(es) to append to the element. (Optional)
 * @param {string} [props.width] CSS-style width. (Optional)
 * @returns {JSX.Element} Shimmering placeholder span element.
 */
function DataPlaceholder(props) {
    const placeholderWidth = props.width ? props.width : undefined;
    const myClass = ('data-placeholder shimmer ' + (props.className || '')).trim();

    return (
        <span
            className={myClass}
            style={{ width: placeholderWidth }}
        />
    );
}

export default DataPlaceholder;
